<template>
  <div class="container-event">
    <b-row>
      <b-col cols="12" class="mb-2">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center" style="gap: 16px">
            <b-button variant="outline-secondary" @click="handleBack">
              <feather-icon icon="ArrowLeftIcon" /> Back to Sports
            </b-button>
            <h4 class="font-weight-bolder mb-0">Add New Event</h4>
          </div>

          <div>
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="handleBack"
              >Cancel</b-button
            >
            <b-button
              @click="handleSubmitCreate"
              variant="success"
              :disabled="loadingCreateEvent"
            >
              <feather-icon icon="PlusIcon" />
              <Spinner v-if="loadingCreateEvent" />
              <template v-else> Create Event </template>
            </b-button>
          </div>
        </div>
      </b-col>

      <b-col cols="12">
        <b-card no-body class="mb-4">
          <b-card-header class="bg-dark text-white">
            📅 New Event Setup
          </b-card-header>
          <b-card-body>
            <h5 class="mt-3 mb-1 text-body font-weight-bold">
              Create Sports Event
            </h5>

            <b-form>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Icon:</span>
                    <b-form-input
                      v-model="form.icon"
                      placeholder="Enter icon link..."
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Order:</span>
                    <b-form-input
                      v-model="form.order"
                      :formatter="formatPrice"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group>
                <label class="font-weight-bold text-warning">Name:</label>
                <b-form-input
                  v-model="form.name"
                  placeholder="Enter event name (e.g., Team A vs Team B)"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span class="font-weight-bold">Short Name:</span>
                <b-form-input
                  v-model="form.shortName"
                  placeholder="Short version (e.g., TEA vs TEB)"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <span class="font-weight-bold">Default Name:</span>
                <b-form-input
                  v-model="form.defaultName"
                  placeholder="Default display name"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span class="font-weight-bold">Description:</span>
                <b-form-textarea
                  v-model="form.description"
                  placeholder="Event description and additional details"
                ></b-form-textarea>
              </b-form-group>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Display:</span>
                    <b-form-radio-group
                      v-model="form.display"
                      :options="yesNoOptions"
                      name="display-options"
                      class="mt-1"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Racing Special:</span>
                    <b-form-radio-group
                      v-model="form.racing"
                      :options="yesNoOptions"
                      name="racing-options"
                      class="mt-1"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>

        <b-card no-body class="mb-4">
          <b-card-header class="bg-dark text-white">
            Event Details
          </b-card-header>
          <b-card-body>
            <b-row class="mt-4">
              <b-col md="6">
                <b-form-group>
                  <p class="font-weight-bold mb-0">
                    Home Team: <span class="text-danger">*</span>
                  </p>
                  <b-form-input
                    v-model="form.homeTeam"
                    placeholder="Enter home team name"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <p class="font-weight-bold mb-0">
                    Away Team: <span class="text-danger">*</span>
                  </p>
                  <b-form-input
                    v-model="form.awayTeam"
                    placeholder="Enter away team name"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="">
              <b-col md="6">
                <b-form-group>
                  <p class="font-weight-bold mb-0">
                    Home Flag: <span class="text-danger">*</span>
                  </p>
                  <!-- <b-form-input
                    v-model="form.homeFlag"
                    placeholder="Enter home flag url"
                  /> -->
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="form.homeFlag"
                      placeholder="Enter home flag link"
                    />

                    <b-input-group-append>
                      <b-button
                        style="padding: 4px; font-size: 10px"
                        variant="secondary"
                        @click="$refs.fileInputHome.$el.click()"
                        >Select File</b-button
                      >
                      <b-form-file
                        ref="fileInputHome"
                        accept=".jpg, .png, .gif, .heic, .jpeg"
                        :hidden="true"
                        plain
                        @change="inputImageRenderer"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <p class="font-weight-bold mb-0">
                    Away Flag: <span class="text-danger">*</span>
                  </p>
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="form.awayFlag"
                      placeholder="Enter away flag link"
                    />

                    <b-input-group-append>
                      <b-button
                        style="padding: 4px; font-size: 10px"
                        variant="secondary"
                        @click="$refs.fileInputAway.$el.click()"
                        >Select File</b-button
                      >
                      <b-form-file
                        ref="fileInputAway"
                        accept=".jpg, .png, .gif, .heic, .jpeg"
                        :hidden="true"
                        plain
                        @change="inputImageRendererAway"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <p class="font-weight-bold mb-0">
                    Venue: <span class="text-danger">*</span>
                  </p>
                  <b-form-input
                    v-model="form.venue"
                    placeholder="Enter venue name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <span class="font-weight-bold">Round/Week:</span>
                  <b-form-input
                    v-model="form.round"
                    placeholder="e.g., Round 15, Week 10"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <p class="font-weight-bold mb-0">
                    Start Time: <span class="text-danger">*</span>
                  </p>
                  <flat-pickr
                    id="startTime"
                    v-model="startTime"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      dateFormat: 'm/d/Y H:i:s',
                      enableSeconds: true,
                      static: true,
                    }"
                    placeholder="mm/dd/yyyy"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <span class="font-weight-bold">Priority:</span>
                  <b-form-select
                    v-model="form.priority"
                    :options="priorityOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <span class="font-weight-bold">Status:</span>
                  <b-form-select
                    v-model="form.status"
                    :options="statusOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-checkbox v-model="form.defaultSettings">
                  <strong>Featured Event</strong>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12">
        <b-card no-body>
          <b-card-header class="text-white" style="background-color: #6c757d">
            Competition Assignment
          </b-card-header>
          <b-card-body>
            <b-row class="mt-2">
              <b-col md="6">
                <span class="font-weight-bold">Sport Category:</span>
                <b-form-select
                  v-model="form.sportCategory"
                  :options="sportCategories"
                ></b-form-select>
              </b-col>

              <b-col md="6">
                <span class="font-weight-bold">League/Competition:</span>
                <b-form-select
                  v-model="form.league"
                  :options="leagues"
                ></b-form-select>
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col md="6">
                <span class="font-weight-bold">Region:</span>
                <b-form-select
                  v-model="form.region"
                  :options="regions"
                ></b-form-select>
              </b-col>
              <b-col md="6">
                <span class="font-weight-bold">Season:</span>
                <b-form-input v-model="form.season" readonly></b-form-input>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12">
        <b-card no-body>
          <b-card-header class="text-white" style="background-color: #0d6efd">
            Initial Markets Setup
          </b-card-header>
          <b-card-body>
            <b-row class="mt-2">
              <b-col md="6">
                <div class="font-weight-bolder">Default Bet Types:</div>
                <b-row>
                  <b-col
                    v-for="(option, index) in defaultBetTypes"
                    :key="'bet-' + index"
                    md="12"
                    class="mt-1"
                  >
                    <b-form-checkbox
                      v-model="formMarket.defaultBetTypes"
                      :value="option.value"
                    >
                      <span class="font-weight-bold">{{ option.text }}</span>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>

              <b-col md="6">
                <div class="font-weight-bolder">Initial Markets:</div>
                <b-row>
                  <b-col
                    v-for="(option, index) in initialMarkets"
                    :key="'market-' + index"
                    md="12"
                    class="mt-1"
                  >
                    <b-form-checkbox
                      v-model="formMarket.initialMarkets"
                      :value="option.value"
                    >
                      <span class="font-weight-bold"> {{ option.text }}</span>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="mr-1" @click="handleBack"
            >Cancel</b-button
          >
          <b-button
            @click="handleSubmitCreate"
            :disabled="loadingCreateEvent"
            variant="success"
          >
            <Spinner v-if="loadingCreateEvent" />
            <template v-else> Create Event </template></b-button
          >
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BInputGroupAppend,
  BFormFile,
  BInputGroup,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";
import Spinner from "@/@core/components/Spinner.vue";
import { v4 as uuidv4 } from "uuid";
import { formatDateSend } from "@/helpers/utils";

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    flatPickr,
    Spinner,
    BInputGroupAppend,
    BFormFile,
    BInputGroup,
  },
  data() {
    return {
      form: {
        icon: "",
        order: null,
        name: "",
        shortName: "",
        defaultName: "",
        officialName: "",
        description: "",
        display: false,
        racing: false,
        status: "",
        priority: "",
        sportCategory: null,
        league: null,
        region: "Australia",
        season: "2024/25",
        homeTeam: "",
        awayTeam: "",
        homeFlag: "",
        awayFlag: "",
        venue: "",
        round: "",
        defaultSettings: false,
      },
      startTime: "",
      yesNoOptions: [
        { value: false, text: "No" },
        { value: true, text: "Yes" },
      ],
      countryOptions: [
        { value: "Australia", text: "Australia" },
        { value: "USA", text: "USA" },
        { value: "UK", text: "UK" },
      ],
      regionOptions: [
        { value: "Australia", text: "Australia" },
        { value: "Asia", text: "Asia" },
      ],
      competitionOptions: [
        { value: "League", text: "League" },
        { value: "Cup", text: "Cup" },
      ],
      statusOptions: [
        { value: "Scheduled", text: "Scheduled" },
        { value: "Live", text: "Live" },
        { value: "Completed", text: "Completed" },
        { value: "Postponed", text: "Postponed" },
      ],
      priorityOptions: [
        { value: "High", text: "High" },
        { value: "Medium", text: "Medium" },
        { value: "Low", text: "Low" },
      ],
      sportCategories: [
        { value: null, text: "Select..." },
        { value: "football", text: "Football" },
        { value: "basketball", text: "Basketball" },
      ],
      leagues: [{ value: null, text: "Select..." }],
      regions: [
        { value: "Australia", text: "Australia" },
        { value: "UK", text: "United Kingdom" },
      ],

      formMarket: {
        defaultBetTypes: ["1x2", "handicap", "overUnder"],
        initialMarkets: ["matchResult", "totalGoals"],
      },
      defaultBetTypes: [
        { value: "1x2", text: "1X2" },
        { value: "handicap", text: "Handicap" },
        { value: "overUnder", text: "Over/Under" },
        { value: "bothTeamsScore", text: "Both Teams to Score" },
        { value: "correctScore", text: "Correct Score" },
      ],
      initialMarkets: [
        { value: "matchResult", text: "Match Result" },
        { value: "totalGoals", text: "Total Goals" },
        { value: "asianHandicap", text: "Asian Handicap" },
        { value: "halfTimeResult", text: "Half Time Result" },
        { value: "firstGoal", text: "First Goal Scorer" },
      ],
    };
  },
  computed: {
    ...mapState("sport/create", ["loadingCreateEvent"]),
  },
  methods: {
    ...mapActions({
      createEvent: "sport/create/createEvent",
      uploadImage: "sport/create/uploadImage",
      getListLeagueOfSport: "sport/list/getListLeagueOfSport",
    }),
       async fetchDetailLeague() {
      const data = await this.getListLeagueOfSport({
       
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching sports list");
      if (this.currentPageLeagues === 1) {
        this.leagues = data.data;
      } else {
        this.leagues = [...this.leagues, ...data.data];
      }
      this.totalLeagues = data.pagination.total;
    },
    formatPrice(value) {
      value = value.replace(/[^0-9.]/g, "");

      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      if (value.includes(".")) {
        const decimalPart = value.split(".")[1];
        if (decimalPart.length > 2) {
          const integerPart = value.split(".")[0];
          value = `${integerPart}.${decimalPart.slice(0, 2)}`;
        }
      }

      return value;
    },
    handleBack() {
      this.$router.push({ name: "trading-sports" });
    },
    async handleSubmitCreate() {
      // return;
      const res = await this.createEvent({
        eventTitle: this.form.name,
        startTime: this.formatDateSend(this.startTime),
        source: "manual",
        eventId: uuidv4(),
        leagueId: this.$route.params.id,
        league: this.$route.params.name,
        sport: "",
        country: this.form.region,
        primaryMarketName: "",
        displayStatus: "",
        bettingStatus: "",
        detailLink: "",
        brandLinksLadbrokes: "",
        brandLinksNeds: "",
        eventType: "",
        entryType: 0,
        stadium: this.form.venue,
        sportCode: this.$route.params.code,
        isAllowedPlaceBetting: true,
        isDisableSyncSport: false,
        status: this.form.status,
        description: this.form.description,
        round: this.form.round,
        scores: [
          {
            role: "HomeTeam",
            team: this.form.homeTeam,
            subFlag: this.form.homeFlag,
          },
          {
            role: "AwayTeam",
            team: this.form.awayTeam,
            subFlag: this.form.awayFlag,
          },
        ],
      });
      if (res) {
        this.showToastSuccess(true, "New event created successfully!");
        this.handleBack();
      }
    },
    async inputImageRenderer(evt) {
      const formData = new FormData();
      const file = evt.target.files[0];
      if (file && file.size <= 10 * 1024 * 1024) {
        formData.append("file", file);
        const res = await this.uploadImage(formData);
        if (res && res[0]) {
          this.form.homeFlag = res[0].url;
        }
      } else {
        this.showToastError("Error", "The file is less than or equal to 10MB");
      }
    },
    async inputImageRendererAway(evt) {
      const formData = new FormData();
      const file = evt.target.files[0];
      if (file && file.size <= 10 * 1024 * 1024) {
        formData.append("file", file);
        const res = await this.uploadImage(formData);
        if (res && res[0]) {
          this.form.awayFlag = res[0].url;
        }
      } else {
        this.showToastError("Error", "The file is less than or equal to 10MB");
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,

      formatDateSend,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.container-event {
  max-width: 1024px;
  margin: auto;
  padding: 16px;
}
</style>
